<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node), 'node-id-' + node.id]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-paper-plane card-envelope-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div class="card-data">
        <p v-if="node.data.title && node.data.postbackId" class="text-center mb-0 postback_title">
          {{ node.data.title }}
        </p>

        <div class="list-group mt-2">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="getSelectedLabelTexts(node)">         
            <small class="text-muted">{{otn_single_html_labels}}</small>
            <p class="mb-0"> {{ getSelectedLabelTexts(node) }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.sequenceIdValue">         
            <small class="text-muted">{{otn_single_template_sequence_name}}</small>
            <p class="mb-0"> {{ node.data.sequenceIdText }}</p>
          </span>
        </div>

      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../functions/utils'

export default {
  name: 'NewPostbackTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    otn_single_html_labels: lang.otn_single_html_labels,
    otn_single_template_sequence_name: lang.otn_single_template_sequence_name,
  }),

  methods: {
    ...templateComponentMethods,

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    },
  }
}
</script>

<style scoped>
  .input_content { width:50% !important;}
  .output_content{ width:50% !important;float:right !important;}
  .card-sockets { padding: 5px 0 !important;}
  .card-envelope-icon { font-size:13px;}
  .postback_title {
    background-color: #f6f4f4 !important;
    border-radius: 7px;
    padding: 0px 10px;
    text-transform:capitalize;
  }
  .label_ids {
    margin-bottom: 0;
    font-size: 13px;
    color: #6e6e6e;
  }
  .sequence_ids {
    margin-bottom: 0;
    font-size: 13px;
    color: #6e6e6e;
  }
</style>